import {react2panel} from 'common/util/react2panel';

import {CohortsBuilderReact} from './index';

export const CohortsBuilderEl = react2panel(`mp-cohorts-query-builder`, CohortsBuilderReact);
